import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from './supabaseClient';

const Blog = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      const { data } = await supabase
        .from('blog_posts')
        .select('*')
        .eq('status', 'published')
        .order('created_at', { ascending: false });
      setPosts(data || []);
      setLoading(false);
    };
    fetchPosts();
  }, []);

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 16px 80px' }}>

      <div style={{ marginBottom: '48px' }}>
        <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#4a7c59', textTransform: 'uppercase', marginBottom: '8px', fontFamily: 'Lato, sans-serif' }}>
          🌿 Plant Price Insights
        </div>
        <h1 style={{ fontFamily: 'Playfair Display, serif', fontSize: '42px', color: '#1e3d20', marginBottom: '12px' }}>
          The True Plant Value Blog
        </h1>
        <p style={{ color: '#4a5e4b', fontFamily: 'Lato, sans-serif', fontSize: '16px', lineHeight: 1.6 }}>
          Real data. Real insights. No guessing. We analyze actual plant sale data to help you buy and sell smarter.
        </p>
      </div>

      {loading ? (
        <p style={{ color: '#4a7c59', fontStyle: 'italic', fontFamily: 'Lato, sans-serif' }}>Loading posts...</p>
      ) : posts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', background: '#fff', borderRadius: '20px', boxShadow: '0 2px 16px rgba(44,74,46,0.08)' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🌱</div>
          <p style={{ color: '#4a5e4b', fontFamily: 'Lato, sans-serif', fontSize: '16px' }}>No posts yet — check back soon!</p>
        </div>
      ) : (
        posts.map((post) => (
          <div key={post.id}
            onClick={() => navigate(`/blog/${post.slug}`)}
            style={{
              background: '#ffffff', borderRadius: '20px', padding: '32px',
              boxShadow: '0 2px 16px rgba(44,74,46,0.08)', marginBottom: '24px',
              border: '1px solid rgba(143,185,154,0.3)', cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 8px 32px rgba(44,74,46,0.15)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 2px 16px rgba(44,74,46,0.08)'}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
              <div style={{ flexShrink: 0, width: '80px', height: '80px' }}>
                {post.image_url ? (
                  <img src={post.image_url} alt={post.title} style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px' }} />
                ) : (
                  <div style={{ fontSize: '48px', lineHeight: '80px', textAlign: 'center' }}>{post.emoji || '🌿'}</div>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
                  {post.category && (
                    <span style={{ background: '#f0f7f1', color: '#4a7c59', padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', fontFamily: 'Lato, sans-serif' }}>
                      {post.category}
                    </span>
                  )}
                  <span style={{ fontSize: '12px', color: '#8b9e8c', fontFamily: 'Lato, sans-serif' }}>
                    {new Date(post.created_at).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                  </span>
                </div>
                <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '24px', color: '#1e3d20', marginBottom: '12px', lineHeight: 1.2 }}>
                  {post.title}
                </h2>
                {post.subtitle && (
                  <p style={{ color: '#4a5e4b', fontFamily: 'Lato, sans-serif', fontSize: '15px', lineHeight: 1.6, marginBottom: '16px' }}>
                    {post.subtitle}
                  </p>
                )}
                <span style={{ color: '#4a7c59', fontFamily: 'Lato, sans-serif', fontSize: '13px', fontWeight: 700 }}>
                  Read more →
                </span>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Blog;